<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useDeviceStore } from './stores/device'
import MainLayout from './components/layout/MainLayout.vue'
import StartMask from './components/common/StartMask.vue'
import { isUpgradeModeDevice } from './core/firmware-device'

const route = useRoute()
const router = useRouter()
const deviceStore = useDeviceStore()
const standalonePaths = ['/login', '/register', '/upgrade']
const isStandaloneRoute = computed(() => standalonePaths.includes(route.path))
const isUserRoute = computed(() => route.path === '/user')

onMounted(async () => {
  if (route.path === '/upgrade') return

  // Initialize device auto-detection with auto-connect
  await deviceStore.initAutoDetection()
  if (navigator.hid) {
    const devices = await navigator.hid.getDevices()
    if (devices.some(isUpgradeModeDevice)) {
      router.replace('/upgrade')
    }
  }
})
</script>

<template>
  <!-- 启动遮罩 - 只在非独立路由时显示 -->
  <StartMask v-if="!isStandaloneRoute" />

  <!-- 主应用内容 -->
  <RouterView v-if="isStandaloneRoute" />
  <MainLayout v-else :hide-sidebar="isUserRoute" :header-always-visible="isUserRoute">
    <RouterView />
  </MainLayout>
</template>
